module.exports = __webpack_public_path__ + "static/media/03.763a93be.png";